import React, { Component } from 'react';
import { observer , inject } from 'mobx-react';
import {Menu , MenuDivider, MenuItem,Button, Icon}from '@blueprintjs/core';
import { Example, IExampleProps } from "@blueprintjs/docs-theme";
import { Popover2 } from "@blueprintjs/popover2";
import { Breadcrumbs, Classes,Intent, ITreeNode, Tree } from "@blueprintjs/core";

@inject("store")
@observer
export default class Toolbar extends Component
{

    save(){
        this.props.store.is_editing = false ;
        localStorage.removeItem(this.props.store.savepath);
        localStorage.setItem(this.props.store.savepath, this.props.store.current_note_parctise);
       }

    cancel(){
        this.props.store.is_editing = false ;
        let cat = localStorage.getItem(this.props.store.savepath);
        if (cat == null){
            cat = "这是练习区域  请单击编辑按钮开始练习。";
        }
        this.props.store.current_note_parctise = cat;
    }

    perfet(){

        if(localStorage.getItem(this.props.store.savepath+"star")!="完美"){
            localStorage.removeItem(this.props.store.savepath+"star");
            localStorage.setItem(this.props.store.savepath+"star","完美");
           this.forceUpdate();
           this.props.store.starchange +=1;
           this.props.changeparentstate();

        }

       
      
       
        
    }

    ok(){
        if(localStorage.getItem(this.props.store.savepath+"star")!="挺好"){
            localStorage.removeItem(this.props.store.savepath+"star");
            localStorage.setItem(this.props.store.savepath+"star","挺好");
            this.forceUpdate();
            this.props.store.starchange +=1;
            this.props.changeparentstate();
        }


      
       
    }

    normal(){
        if(localStorage.getItem(this.props.store.savepath+"star")!="还行"){
            localStorage.removeItem(this.props.store.savepath+"star");
            localStorage.setItem(this.props.store.savepath+"star","还行");
          this.forceUpdate();
          this.props.store.starchange +=1;
          this.props.changeparentstate();
        }
     
    
     

    }

    bad(){

        if(localStorage.getItem(this.props.store.savepath+"star")!="较差"){
            localStorage.removeItem(this.props.store.savepath+"star");
            localStorage.setItem(this.props.store.savepath+"star","较差");
            this.forceUpdate();
            this.props.store.starchange +=1;
            this.props.changeparentstate();
        }
    
        
        
        
    }

    verybad(){

        if(localStorage.getItem(this.props.store.savepath+"star")!="很差"){
            localStorage.removeItem(this.props.store.savepath+"star");
            localStorage.setItem(this.props.store.savepath+"star","很差");
            this.forceUpdate();
            this.props.store.starchange +=1;
            this.props.changeparentstate();
        }
     
      
      
    }

    edit(){
        this.props.store.is_editing = !this.props.store.is_editing;
        let cat = localStorage.getItem(this.props.store.savepath);
        if (cat == null){
            cat = "";
        }
        this.props.store.current_note_parctise = cat;
        this.forceUpdate();

    }

    render()
    {
        const twostar = <>
        <Icon icon = "star" />
        <Icon icon = "star" />
        </>

const threestar = <>
<Icon icon = "star"/>
<Icon icon = "star" />
<Icon icon = "star" />
</>

        const exampleMenu = (
            <Menu>
                <MenuItem icon="heart" text="完美"  labelElement = {threestar} label = {twostar} onClick={()=>this.perfet()} />
                <MenuItem icon="new-layers" text="挺好" labelElement = {twostar} label = {twostar} onClick={()=>this.ok()}  />
                <MenuItem icon="layers" text="还行" labelElement = {threestar}  onClick={()=>this.normal()} />
                <MenuItem icon="layer" text="较差" labelElement = {twostar} onClick={()=>this.bad()} />
                <MenuItem icon="heart-broken" text="很差" labelElement = {<Icon icon = "star" />} onClick={()=>this.verybad()} />
           
               
            </Menu>
        );

        return    <div className="toolbar">
                    
                    { this.props.store.is_editing ? <>
                    
                   

                    <Button icon="floppy-disk" onClick={()=>this.save() } minimal={true}/>
                    
                    <Button icon="cross" minimal={true}onClick={()=>this.cancel()}/>
                    </> :<>
                    <Button icon="edit" minimal={true} onClick={()=>this.edit() }/>
                    <div>成绩：{ localStorage.getItem(this.props.store.savepath+"star")}</div>
                    <Example options={false} {...this.props}>
                    <Popover2 content={exampleMenu} placement="right-end">
                    <Button icon="endorsed" text="打分" />
                     </Popover2>
                     </Example>
                    </> }
                    
                    
                   
                </div>;
    }
}